import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { GetAdminAdmissionService } from "./get-admin-admission.service";
import { PaymentMethodEnum } from "src/app/shared/interfaces";

@Injectable({
    providedIn: "root",
})
export class AdminAdmissionService extends GetAdminAdmissionService {
    constructor(protected override httpClient: HttpClient) {
        super(httpClient);
    }

    exportAdmissionsExcel(status?: string) {
        return this.httpClient.get<{ file: string }>(
            `${environment.API_URL}${
                status ? `/admin/admission/excel/${status}/list/` : "/admin/approved-admission/excel/list/"
            }`,
        );
    }

    sendAdmissionMail(id: string, email: string) {
        return this.httpClient.post(`${environment.API_URL}/admin/enquiries/send-admission-mail/${id}/`, { email });
    }

    exportEnquiriesExcel() {
        return this.httpClient.get<{ file: string }>(`${environment.API_URL}${"/admin/enquiries/excel/list/"}`);
    }

    exportIdCardExcel() {
        return this.httpClient.get<{ file: string }>(`${environment.API_URL}${"/admin/student-id-card/excel/"}`);
    }

    receiveSepratePayment(data: { instalment_id: string; amount: number; payment_method: PaymentMethodEnum }) {
        return this.httpClient.post<{ admission: string }>(`${environment.API_URL}/schools/admin/receive-seprate-payment/`, data);
    }

    previewMigration(data: {
        from_academic_year_id?: string;
        to_academic_year_id?: string;
        from_standard_id?: string;
        to_standard_id?: string;
        to_batch_id?: string;
        to_division?: string | null;
        admission_ids: string[];
    }) {
        return this.httpClient.post(`${environment.API_URL}/admin/migration/preview/`, data);
    }

    executeMigration(data: {
        from_academic_year_id?: string;
        to_academic_year_id?: string;
        from_standard_id?: string;
        to_standard_id?: string;
        to_batch_id?: string;
        admission_ids: string[];
    }) {
        return this.httpClient.post(`${environment.API_URL}/admin/migration/execute/`, data);
    }
}
